import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Dimension = iotsUtils.fromList(
	constants.wholeHouse.bom.quantityAggregation.dimensions
);
